import React from "react";

const SmallArrowLeft = (props) => (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.625 12.625L0.625 6.625L6.625 0.625"
            stroke="#242424"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SmallArrowLeft;
